/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ km: NonNullable<unknown> }} Opportunitiesareacaption2Inputs */

const en_opportunitiesareacaption2 = /** @type {(inputs: Opportunitiesareacaption2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Areas are about ${i?.km} km across. Demand counts people who opened the app; supply counts published events and venues in the same area.`)
};

const de_opportunitiesareacaption2 = /** @type {(inputs: Opportunitiesareacaption2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gebiete sind etwa ${i?.km} km groß. Nachfrage zählt Personen, die die App geöffnet haben; Angebot zählt veröffentlichte Events und Orte im selben Gebiet.`)
};

/**
* | output |
* | --- |
* | "Areas are about {km} km across. Demand counts people who opened the app; supply counts published events and venues in the same area." |
*
* @param {Opportunitiesareacaption2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiesareacaption2 = /** @type {((inputs: Opportunitiesareacaption2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiesareacaption2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiesareacaption2(inputs)
	return de_opportunitiesareacaption2(inputs)
});
export { opportunitiesareacaption2 as "opportunitiesAreaCaption" }